import {priceFormat} from "@pg-mono/string-utils";

export const getPriceMessage = (upperStr: string, lowerStr: string) => {
    const upper = parseInt(upperStr);
    const lower = parseInt(lowerStr);
    if (!upper && !lower) {
        return "";
    }
    if (!upper) {
        return `od ${priceFormat(lower)}`;
    }
    if (!lower) {
        return `do ${priceFormat(upper)}`;
    }
    return `${priceFormat(lower)} - ${priceFormat(upper)}`;
};
import {priceFormat} from "@pg-mono/string-utils";

export const getPriceMessage = (upperStr: string, lowerStr: string) => {
    const upper = parseInt(upperStr);
    const lower = parseInt(lowerStr);
    if (!upper && !lower) {
        return "";
    }
    if (!upper) {
        return `od ${priceFormat(lower)}`;
    }
    if (!lower) {
        return `do ${priceFormat(upper)}`;
    }
    return `${priceFormat(lower)} - ${priceFormat(upper)}`;
};
